import { graphql } from '@frontend/gql/social';

export const socialAdsAnalyticsFragment = graphql(`
  fragment SocialAdsAnalytics_Query on Query {
    client(id: $clientId) {
      id
      metaAdAccounts {
        id
        name
        createdAt
        updatedAt
        status
      }
      currentInterval: sumInsights(
        filter: { range: $currentIntervalRange, isAspireSourced: true }
        fromOldData: $fromOldData
      ) {
        ...TotalAdsCard_MetaSumInsights
        ...TotalSpendCard_MetaSumInsights
        ...SalesGeneratedCard_MetaSumInsights
        ...RoasCard_MetaSumInsights
        ...Clicks_MetaSumInsights
        ...Reach_MetaSumInsights
        ...Impressions_MetaSumInsights
        ...Members_MetaSumInsights
        ...Posts_MetaSumInsights
        ...Cpc_MetaSumInsights
        ...Cpm_MetaSumInsights
        ...Cpp_MetaSumInsights
        ...Ctr_MetaSumInsights
        ...CpcRadial_MetaSumInsights
        ...CpmRadial_MetaSumInsights
        ...CppRadial_MetaSumInsights
        ...CtrRadial_MetaSumInsights
        ...SocialAds_CurrencyFragment
      }
      currentIntervalsIntervalInsights: intervalInsights(
        filter: { range: $currentIntervalRange, isAspireSourced: true }
        fromOldData: $fromOldData
      ) {
        ...AdSpendVsSalesChart_MetaIntervalInsights
        ...RoasOverTimeChart_MetaInsights
        ...ImpressionsChart_MetaInsights
        ...ReachChart_MetaInsights
        ...ViewsPerPersonChart_MetaInsights
      }
      currentIntervalsIntervalInsightsNotAspireSourced: intervalInsights(
        filter: { range: $currentIntervalRange, isAspireSourced: false }
        fromOldData: $fromOldData
      ) {
        ...AdSpendVsSalesChart_MetaIntervalInsights
        ...RoasOverTimeChart_MetaInsights
        ...ImpressionsChart_MetaInsights
        ...ReachChart_MetaInsights
        ...ViewsPerPersonChart_MetaInsights
      }
      previousInterval: sumInsights(
        filter: { range: $previousIntervalRange, isAspireSourced: true }
        fromOldData: $fromOldData
      ) {
        ...TotalAdsCard_MetaSumInsights
        ...TotalSpendCard_MetaSumInsights
        ...SalesGeneratedCard_MetaSumInsights
        ...RoasCard_MetaSumInsights
        ...Clicks_MetaSumInsights
        ...Reach_MetaSumInsights
        ...Impressions_MetaSumInsights
        ...Members_MetaSumInsights
        ...Posts_MetaSumInsights
        ...Cpc_MetaSumInsights
        ...Cpm_MetaSumInsights
        ...Cpp_MetaSumInsights
        ...Ctr_MetaSumInsights
      }
      currentIntervalNotAspireSourced: sumInsights(
        filter: { range: $currentIntervalRange, isAspireSourced: false }
        fromOldData: $fromOldData
      ) {
        ...TotalAdsCard_MetaSumInsights
        ...TotalSpendCard_MetaSumInsights
        ...SalesGeneratedCard_MetaSumInsights
        ...RoasCard_MetaSumInsights
        ...Cpc_MetaSumInsights
        ...Cpm_MetaSumInsights
        ...Cpp_MetaSumInsights
        ...Ctr_MetaSumInsights
        ...CpcRadial_MetaSumInsights
        ...CpmRadial_MetaSumInsights
        ...CppRadial_MetaSumInsights
        ...CtrRadial_MetaSumInsights
      }
      previousIntervalNotAspireSourced: sumInsights(
        filter: { range: $previousIntervalRange, isAspireSourced: false }
        fromOldData: $fromOldData
      ) {
        ...TotalAdsCard_MetaSumInsights
        ...TotalSpendCard_MetaSumInsights
        ...SalesGeneratedCard_MetaSumInsights
        ...RoasCard_MetaSumInsights
        ...Cpc_MetaSumInsights
        ...Cpm_MetaSumInsights
        ...Cpp_MetaSumInsights
        ...Ctr_MetaSumInsights
      }
    }
  }
`);

export const insightsByClientId = graphql(`
  query GetInsightsByClientId(
    $clientId: String!
    $currentIntervalRange: RangeInput!
    $previousIntervalRange: RangeInput!
    $fromOldData: Boolean
  ) {
    ...SocialAdsAnalytics_Query
  }
`);

export const getMetaAdAccountsForFilters = graphql(`
  query GetMetaAdAccountsForFilters($clientId: String!) {
    client(id: $clientId) {
      id
      metaAdAccounts(filter: { statuses: [ACTIVE, ANY_ACTIVE] }) {
        id
        name
        status
        metaAdCampaigns {
          id
          name
          objective
          status
          metaAdSets {
            id
            name
            status
            metaAds {
              id
              name
              status
              metaAdMetaAdCreatives {
                id
                instagramBrandedContent
              }
            }
          }
        }
      }
    }
  }
`);

// TODO: This query will be implemented once backend supports member-campaign associations
// export const getMembersWithPartnershipAds = graphql(`
//   query GetMembersWithPartnershipAds($clientId: String!) {
//     client(id: $clientId) {
//       id
//       # TODO: This query needs backend support
//       # We need a new field that returns members associated with:
//       # 1. Campaigns/AdSets with paid partnership ads (instagramBrandedContent != null)
//       # 2. Campaigns/AdSets with UGC/Influencer/Aspire in names
//       # 3. Member association data connecting members to their campaigns/ads
//       #
//       # For now, this is a placeholder - backend needs to implement:
//       # membersWithPartnershipAds {
//       #   id
//       #   name
//       #   email
//       #   profilePicture
//       #   hasPartnershipAds
//       #   partnershipCampaigns {
//       #     id
//       #     name
//       #     hasPaidPartnershipAds
//       #   }
//       #   ugcInfluencerCampaigns {
//       #     id
//       #     name
//       #   }
//       # }
//     }
//   }
// `);
